import { onMounted, computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import axios from '@/axios'
import router from "@/router"
import useApp from './useApp'
import { AxiosHeaders } from 'axios'


const useCompany = () => {
    const store = useStore()
    const {ToastMsg,ToastMsgError,ToastMsgWarning,ToastMsgInfo,ToastMsgSuccess
    } = useApp();
    const selectedCompanyIndex = ref(null);
    const deviceToAdd = ref(null);
    const companyToDelete = ref(null);
    const newCompany = ref({ name: '', devices: [] });
    const availableDevices = computed(() => store.state.devices);
    const axiosHeaders = {
        headers: {
            token: store.state.auth.token,
        },
    };
    
    const createCompany = async () => {
        try {
            axios.post("/company",newCompany.value, axiosHeaders)
                .then(resp => {
                    if (resp.data.status == "success"){
                        ToastMsgInfo("Empresa Creada Con exito !", "cloud", 3000);
                    }
                    newCompany.value = { name: '', devices: [] };
                    store.dispatch("getCompanies")
                })
                .catch(error => {
                    console.log(error)
                })

        } catch (error) {
            console.log(error)
        }

    }

    const deleteCompany = async () => {
        if (!confirm("¿Estás seguro de eliminar esta empresa permanentemente?")) return;
        
        axios.delete(`/company/${companyToDelete.value}`, axiosHeaders)
        .then(resp => {
            if (resp.data.status == "success"){
                ToastMsgWarning("Empresa Elimniada!", "cloud", 5000);  
                companyToDelete.value = null;
                selectedCompanyIndex.value = null;
                store.dispatch("getCompanies")
            }
        }).catch(error => {
            ToastMsgError("Error Empresa no Eliminada !", "cloud", 5000)
            console.log(error)
        })
        
    };

    const removeDeviceFromCompany = async (devId) => {
        if (!confirm("¿Quitar dispositivo de la empresa?")) return;

        const companyId = store.state.companies[selectedCompanyIndex.value]._id;
        const company_name = store.state.companies[selectedCompanyIndex.value].name
        const devices = store.state.companies[selectedCompanyIndex.value].devices.filter(id => id !== devId);
            
        const toSend = {
            _id :companyId,
            devices
        }
            
        axios.put("/company", toSend, axiosHeaders)
        .then(resp=>{
            if (resp.data.status == "success"){
                ToastMsgSuccess(`Dispositivos Actualizados! -> ${company_name}`, "cloud", 5000)
                store.dispatch("getCompanies")
            }
        }).catch( error =>{
            ToastMsgError("Error al Actualizar !", "cloud", 5000)
            console.log(error)
        })
    

    };

    const addDeviceToCompany = async () => {

        const companyId = store.state.companies[selectedCompanyIndex.value]._id;
        const devId = deviceToAdd.value;
        
        if (store.state.companies[selectedCompanyIndex.value].devices.includes(devId)){
            ToastMsgWarning("Dispositivo Ya fue Agregado!", "cloud", 3000)
        }else {
            const devices = store.state.companies[selectedCompanyIndex.value].devices
            devices.push(devId);

            const toSend = {
                _id : companyId,
                devices
            }
            axios.put("/company", toSend, axiosHeaders )
            .then(resp => {
                if (resp.data.status == "success"){
                    ToastMsgSuccess("Dispositivos Actualizados !", "cloud", "3000" );
                    store.dispatch("getCompanies")
                }
            }).catch(error=>{
                console.log(error)
                ToastMsgError("Error al intentear Actualizar", "cloud", 3000);
            })


        }
        deviceToAdd.value = null;
    };

    const getDeviceName = (id) => {
        const dev = availableDevices.value.find(d => d._id === id);
        return dev ? dev.name : 'Desconocido';
    };

    onMounted(() => {
        store.dispatch("getCompanies")
    })



    return {
        newCompany,
        selectedCompanyIndex,
        deviceToAdd,
        companyToDelete,
        availableDevices,
        createCompany,
        deleteCompany,
        removeDeviceFromCompany,
        addDeviceToCompany,
        getDeviceName
    }
}

export default useCompany